import React from "react";
import * as m from "../../lib/model";
import { Gauge, Filter, AlarmClock, FileCheck2, Radar, Table2, Mail, Users, ListOrdered, Activity, CalendarRange, UsersRound, FileSearch, Landmark, Scale, FileSignature, Building } from "lucide-react";

const ICONS = {
  scoreboard: Gauge, summary: FileSearch, timeline: CalendarRange, funnel: Filter, followups: AlarmClock, readiness: FileCheck2,
  sources: Radar, pipeline: Table2, investors: Users, team: UsersRound, outreach: Mail,
  dscoreboard: Gauge, dtimeline: CalendarRange, dpipeline: Landmark, dterms: FileSignature, dsummary: FileSearch, dcompare: Scale, dfollowups: AlarmClock, dlenders: Building, dteam: UsersRound,
};

const raiseMetrics = (s, tl) => {
  const fu = s?.followUps || {};
  return [
    ["Close in", tl ? `${tl.daysToClose}d` : "—", tl && tl.daysToClose < 0 ? "neg" : ""],
    ["Target", s?.target ? m.fmt$(s.target) : "—"], ["Closed", m.fmt$(s?.closed || 0), s?.closed ? "pos" : ""],
    ["Remaining", s?.target ? m.fmt$(s.remaining) : "—"], ["Weighted", m.fmt$(s?.weighted || 0)], ["Avg ticket", m.fmt$(s?.avgTicket || 0)],
    ["Overdue", fu.overdue || 0, fu.overdue ? "neg" : ""],
  ];
};

export const CapitalRail = ({ s, tl, sections, active, onSelect, metrics, title = "Capital markets sections", liveLabel = "Raise · live" }) => {
  const rows = metrics || raiseMetrics(s, tl);
  return (
    <aside className="asmp-rail" data-testid="cm-rail">
      <div className="rail-title"><ListOrdered size={12} /> {title}</div>
      <nav className="rail-nav">
        {sections.map((sec, i) => {
          const Icon = ICONS[sec.id] || Gauge;
          return (
            <button key={sec.id} className={`rail-link ${active === sec.id ? "active" : ""}`} onClick={() => onSelect(sec.id)} data-testid={`cm-rail-${sec.id}`}>
              <span className="rail-num">{i + 1}</span><Icon size={13} className="rail-ico" /><span className="rail-lbl">{sec.label}</span>
              {sec.badge ? <span className="rail-badge">{sec.badge}</span> : null}
            </button>
          );
        })}
      </nav>
      <div className="rail-foot">
        <div className="rail-title" style={{ paddingTop: 10 }}><Activity size={12} /> {liveLabel}</div>
        <div className="rail-metrics" data-testid="cm-rail-metrics">
          {rows.map(([k, v, cls]) => <div key={k}><span>{k}</span><b className={cls || ""}>{v}</b></div>)}
        </div>
      </div>
    </aside>
  );
};
